/**
 * Base de Dados Estratégica B2B - 500 Cidades em 4 Fases de Conversão
 * Organizada por Potencial de Lucratividade, Dinheiro em Caixa e Baixa Concorrência de Agências
 */

export interface B2BCityEntry {
  nome: string;
  uf: string;
  fase: 1 | 2 | 3 | 4;
  ordem: number;
  populacao?: number;
  descricao?: string;
  lat: number;
  lng: number;
}

// =========================================================================
// FASE 1: Polos de Riqueza e Agronegócio (1 a 115)
// Cidades do interior com fortíssimo PIB agroindustrial, alta liquidez e carência de agências locais
// =========================================================================
export const RAW_FASE_1 = [
  { nome: 'Sinop', uf: 'MT', lat: -11.8608, lng: -55.5097, populacao: 196312 },
  { nome: 'Sorriso', uf: 'MT', lat: -12.5425, lng: -55.7214, populacao: 110618 },
  { nome: 'Lucas do Rio Verde', uf: 'MT', lat: -13.0642, lng: -55.9108, populacao: 83770 },
  { nome: 'Primavera do Leste', uf: 'MT', lat: -15.5583, lng: -54.2961, populacao: 85146 },
  { nome: 'Tangará da Serra', uf: 'MT', lat: -14.6228, lng: -57.4914, populacao: 106434 },
  { nome: 'Rondonópolis', uf: 'MT', lat: -16.4678, lng: -54.6369, populacao: 244897 },
  { nome: 'Nova Mutum', uf: 'MT', lat: -13.8294, lng: -56.0828, populacao: 55648 },
  { nome: 'Campo Novo do Parecis', uf: 'MT', lat: -13.6742, lng: -57.8878, populacao: 45893 },
  { nome: 'Barra do Garças', uf: 'MT', lat: -15.8942, lng: -52.2567, populacao: 69210 },
  { nome: 'Cáceres', uf: 'MT', lat: -16.0764, lng: -57.6814, populacao: 89681 },
  { nome: 'Rio Verde', uf: 'GO', lat: -17.7928, lng: -50.9192, populacao: 225696 },
  { nome: 'Jataí', uf: 'GO', lat: -17.8814, lng: -51.7144, populacao: 105729 },
  { nome: 'Catalão', uf: 'GO', lat: -18.1658, lng: -47.9464, populacao: 110983 },
  { nome: 'Itumbiara', uf: 'GO', lat: -18.4192, lng: -49.2158, populacao: 107970 },
  { nome: 'Senador Canedo', uf: 'GO', lat: -16.7083, lng: -49.0917, populacao: 155635 },
  { nome: 'Formosa', uf: 'GO', lat: -15.5392, lng: -47.3347, populacao: 115901 },
  { nome: 'Maringá', uf: 'PR', lat: -23.4209, lng: -51.9331, populacao: 409657 },
  { nome: 'Cascavel', uf: 'PR', lat: -24.9578, lng: -53.4594, populacao: 348051 },
  { nome: 'Toledo', uf: 'PR', lat: -24.7139, lng: -53.7431, populacao: 150470 },
  { nome: 'Guarapuava', uf: 'PR', lat: -25.3953, lng: -51.4625, populacao: 182644 },
  { nome: 'Pato Branco', uf: 'PR', lat: -26.2289, lng: -52.6708, populacao: 91836 },
  { nome: 'Francisco Beltrão', uf: 'PR', lat: -26.0792, lng: -53.0539, populacao: 96666 },
  { nome: 'Arapongas', uf: 'PR', lat: -23.4189, lng: -51.4239, populacao: 119138 },
  { nome: 'Campo Mourão', uf: 'PR', lat: -24.0458, lng: -52.3789, populacao: 99458 },
  { nome: 'Umuarama', uf: 'PR', lat: -23.7664, lng: -53.3250, populacao: 117072 },
  { nome: 'Paranavaí', uf: 'PR', lat: -23.0817, lng: -52.4644, populacao: 91450 },
  { nome: 'Medianeira', uf: 'PR', lat: -25.2972, lng: -54.0939, populacao: 54369 },
  { nome: 'Palotina', uf: 'PR', lat: -24.2839, lng: -53.8406, populacao: 35011 },
  { nome: 'Passo Fundo', uf: 'RS', lat: -28.2611, lng: -52.4083, populacao: 206224 },
  { nome: 'Chapecó', uf: 'SC', lat: -27.1006, lng: -52.6153, populacao: 254781 },
  { nome: 'Itajaí', uf: 'SC', lat: -26.9078, lng: -48.6619, populacao: 264054 },
  { nome: 'Luís Eduardo Magalhães', uf: 'BA', lat: -12.0958, lng: -45.7958, populacao: 107909 },
  { nome: 'Petrolina', uf: 'PE', lat: -9.3989, lng: -40.5008, populacao: 386786 },
  { nome: 'Juazeiro', uf: 'BA', lat: -9.4167, lng: -40.5033, populacao: 235816 },
  { nome: 'Dourados', uf: 'MS', lat: -22.2231, lng: -54.8119, populacao: 243368 },
  { nome: 'Três Lagoas', uf: 'MS', lat: -20.7850, lng: -51.7042, populacao: 132152 },
  { nome: 'Ponta Porã', uf: 'MS', lat: -22.5361, lng: -55.7256, populacao: 92017 },
  { nome: 'Maracaju', uf: 'MS', lat: -21.6144, lng: -55.1683, populacao: 45047 },
  { nome: 'Naviraí', uf: 'MS', lat: -23.0650, lng: -54.1906, populacao: 50457 },
  { nome: 'Nova Andradina', uf: 'MS', lat: -22.2397, lng: -53.3436, populacao: 48563 },
  { nome: 'Sidrolândia', uf: 'MS', lat: -20.9317, lng: -54.9614, populacao: 47118 },
  { nome: 'Araguaína', uf: 'TO', lat: -7.1903, lng: -48.2072, populacao: 171301 },
  { nome: 'Gurupi', uf: 'TO', lat: -11.7297, lng: -49.0686, populacao: 85126 },
  { nome: 'Paraíso do Tocantins', uf: 'TO', lat: -10.1750, lng: -48.8828, populacao: 52360 },
  { nome: 'Porto Nacional', uf: 'TO', lat: -10.7083, lng: -48.4172, populacao: 64498 },
  { nome: 'Parauapebas', uf: 'PA', lat: -6.0678, lng: -49.9042, populacao: 266424 },
  { nome: 'Castanhal', uf: 'PA', lat: -1.2967, lng: -47.9258, populacao: 192262 },
  { nome: 'Marabá', uf: 'PA', lat: -5.3686, lng: -49.1178, populacao: 266536 },
  { nome: 'Balsas', uf: 'MA', lat: -7.5322, lng: -46.0358, populacao: 101767 },
  { nome: 'Imperatriz', uf: 'MA', lat: -5.5267, lng: -47.4917, populacao: 273110 },
  { nome: 'Açailândia', uf: 'MA', lat: -4.9458, lng: -47.5028, populacao: 106550 },
  { nome: 'Erechim', uf: 'RS', lat: -27.6339, lng: -52.2689, populacao: 105705 },
  { nome: 'Lajeado', uf: 'RS', lat: -29.4678, lng: -51.9614, populacao: 93358 },
  { nome: 'Bento Gonçalves', uf: 'RS', lat: -29.1717, lng: -51.5189, populacao: 123151 },
  { nome: 'Santa Cruz do Sul', uf: 'RS', lat: -29.7189, lng: -52.4286, populacao: 133230 },
  { nome: 'Ijuí', uf: 'RS', lat: -28.3878, lng: -53.9147, populacao: 84407 },
  { nome: 'Vacaria', uf: 'RS', lat: -28.5039, lng: -50.9339, populacao: 64187 },
  { nome: 'Carazinho', uf: 'RS', lat: -28.2839, lng: -52.7864, populacao: 61804 },
  { nome: 'Cruz Alta', uf: 'RS', lat: -28.6389, lng: -53.6064, populacao: 58913 },
  { nome: 'Panambi', uf: 'RS', lat: -28.2928, lng: -53.5019, populacao: 43515 },
  { nome: 'Santa Rosa', uf: 'RS', lat: -27.8708, lng: -54.4817, populacao: 76963 },
  { nome: 'Bagé', uf: 'RS', lat: -31.3314, lng: -54.1069, populacao: 117938 },
  { nome: 'Concórdia', uf: 'SC', lat: -27.2339, lng: -52.0239, populacao: 81646 },
  { nome: 'Joaçaba', uf: 'SC', lat: -27.1778, lng: -51.5039, populacao: 30146 },
  { nome: 'Videira', uf: 'SC', lat: -27.0083, lng: -51.1517, populacao: 55436 },
  { nome: 'Xanxerê', uf: 'SC', lat: -26.8747, lng: -52.4039, populacao: 51607 },
  { nome: 'Caçador', uf: 'SC', lat: -26.7753, lng: -51.0125, populacao: 73720 },
  { nome: 'Canoinhas', uf: 'SC', lat: -26.1772, lng: -50.3900, populacao: 55016 },
  { nome: 'Barreiras', uf: 'BA', lat: -12.1528, lng: -44.9961, populacao: 159743 },
  { nome: 'Eunápolis', uf: 'BA', lat: -16.3778, lng: -39.5858, populacao: 113709 },
  { nome: 'Teixeira de Freitas', uf: 'BA', lat: -16.6833, lng: -39.7417, populacao: 145223 },
  { nome: 'Vitória da Conquista', uf: 'BA', lat: -14.8661, lng: -40.8394, populacao: 370868 },
  { nome: 'Sobral', uf: 'CE', lat: -3.6894, lng: -40.3489, populacao: 203062 },
  { nome: 'Juazeiro do Norte', uf: 'CE', lat: -7.2131, lng: -39.3153, populacao: 286120 },
  { nome: 'Crato', uf: 'CE', lat: -7.2344, lng: -39.4092, populacao: 131050 },
  { nome: 'Mossoró', uf: 'RN', lat: -5.1878, lng: -37.3442, populacao: 264577 },
  { nome: 'Parnaíba', uf: 'PI', lat: -2.9039, lng: -41.7769, populacao: 162159 },
  { nome: 'Picos', uf: 'PI', lat: -7.0769, lng: -41.4669, populacao: 83090 },
  { nome: 'Uberaba', uf: 'MG', lat: -19.7483, lng: -47.9319, populacao: 337846 },
  { nome: 'Patos de Minas', uf: 'MG', lat: -18.5789, lng: -46.5181, populacao: 159214 },
  { nome: 'Pouso Alegre', uf: 'MG', lat: -22.2300, lng: -45.9364, populacao: 152212 },
  { nome: 'Varginha', uf: 'MG', lat: -21.5514, lng: -45.4328, populacao: 136467 },
  { nome: 'Poços de Caldas', uf: 'MG', lat: -21.7853, lng: -46.5653, populacao: 163742 },
  { nome: 'Araguari', uf: 'MG', lat: -18.6486, lng: -48.1928, populacao: 117825 },
  { nome: 'Passos', uf: 'MG', lat: -20.7189, lng: -46.6097, populacao: 111998 },
  { nome: 'Lavras', uf: 'MG', lat: -21.2464, lng: -45.0014, populacao: 104761 },
  { nome: 'Alfenas', uf: 'MG', lat: -21.4258, lng: -45.9469, populacao: 80000 },
  { nome: 'Itajubá', uf: 'MG', lat: -22.4261, lng: -45.4528, populacao: 93073 },
  { nome: 'São Sebastião do Paraíso', uf: 'MG', lat: -20.9167, lng: -46.9917, populacao: 71796 },
  { nome: 'Unaí', uf: 'MG', lat: -16.3578, lng: -46.9056, populacao: 86619 },
  { nome: 'Franca', uf: 'SP', lat: -20.5386, lng: -47.4008, populacao: 352537 },
  { nome: 'Barretos', uf: 'SP', lat: -20.5572, lng: -48.5678, populacao: 122485 },
  { nome: 'Bebedouro', uf: 'SP', lat: -20.9497, lng: -48.4792, populacao: 76373 },
  { nome: 'Sertãozinho', uf: 'SP', lat: -21.1378, lng: -47.9897, populacao: 126887 },
  { nome: 'Catanduva', uf: 'SP', lat: -21.1389, lng: -48.9728, populacao: 115785 },
  { nome: 'Votuporanga', uf: 'SP', lat: -20.4228, lng: -49.9728, populacao: 96634 },
  { nome: 'Fernandópolis', uf: 'SP', lat: -20.2833, lng: -50.2461, populacao: 69402 },
  { nome: 'Andradina', uf: 'SP', lat: -20.8961, lng: -51.3789, populacao: 59783 },
  { nome: 'Araçatuba', uf: 'SP', lat: -21.2089, lng: -50.4328, populacao: 200124 },
  { nome: 'Birigui', uf: 'SP', lat: -21.2889, lng: -50.3400, populacao: 118982 },
  { nome: 'Presidente Prudente', uf: 'SP', lat: -22.1256, lng: -51.3889, populacao: 225668 },
  { nome: 'Assis', uf: 'SP', lat: -22.6617, lng: -50.4178, populacao: 101409 },
  { nome: 'Ourinhos', uf: 'SP', lat: -22.9789, lng: -49.8708, populacao: 103970 },
  { nome: 'Marília', uf: 'SP', lat: -22.2139, lng: -49.9458, populacao: 237627 },
  { nome: 'Lins', uf: 'SP', lat: -21.6789, lng: -49.7500, populacao: 74779 },
  { nome: 'Bauru', uf: 'SP', lat: -22.3147, lng: -49.0606, populacao: 379146 },
  { nome: 'Jaú', uf: 'SP', lat: -22.2964, lng: -48.5586, populacao: 133440 },
  { nome: 'Botucatu', uf: 'SP', lat: -22.8858, lng: -48.4450, populacao: 145155 },
  { nome: 'São Manuel', uf: 'SP', lat: -22.7308, lng: -48.5708, populacao: 37289 },
  { nome: 'Avaré', uf: 'SP', lat: -23.0989, lng: -48.9258, populacao: 91232 },
  { nome: 'Itapetininga', uf: 'SP', lat: -23.5917, lng: -48.0531, populacao: 157790 },
  { nome: 'Tatuí', uf: 'SP', lat: -23.3556, lng: -47.8569, populacao: 123934 },
  { nome: 'Lençóis Paulista', uf: 'SP', lat: -22.5989, lng: -48.8000, populacao: 66505 },
  { nome: 'Piraju', uf: 'SP', lat: -23.1950, lng: -49.3839, populacao: 29286 },
  { nome: 'Ibitinga', uf: 'SP', lat: -21.7578, lng: -48.8289, populacao: 60033 }
];

// =========================================================================
// FASE 2: Grandes Polos Regionais (116 a 231)
// Centros de consumo de grande porte, serviços e alto volume financeiro
// =========================================================================
export const RAW_FASE_2 = [
  { nome: 'Jundiaí', uf: 'SP', lat: -23.1857, lng: -46.8978, populacao: 443116 },
  { nome: 'Sorocaba', uf: 'SP', lat: -23.5015, lng: -47.4526, populacao: 723574 },
  { nome: 'Ribeirão Preto', uf: 'SP', lat: -21.1775, lng: -47.8103, populacao: 698259 },
  { nome: 'Londrina', uf: 'PR', lat: -23.3045, lng: -51.1696, populacao: 555965 },
  { nome: 'Joinville', uf: 'SC', lat: -26.3045, lng: -48.8487, populacao: 616323 },
  { nome: 'Uberlândia', uf: 'MG', lat: -18.9186, lng: -48.2772, populacao: 713232 },
  { nome: 'Juiz de Fora', uf: 'MG', lat: -21.7642, lng: -43.3503, populacao: 540756 },
  { nome: 'Feira de Santana', uf: 'BA', lat: -12.2664, lng: -38.9664, populacao: 616279 },
  { nome: 'Campina Grande', uf: 'PB', lat: -7.2219, lng: -35.8811, populacao: 419379 },
  { nome: 'Santos', uf: 'SP', lat: -23.9608, lng: -46.3331, populacao: 418608 },
  { nome: 'Montes Claros', uf: 'MG', lat: -16.7282, lng: -43.8578, populacao: 414240 },
  { nome: 'Anápolis', uf: 'GO', lat: -16.3267, lng: -48.9533, populacao: 398817 },
  { nome: 'Caruaru', uf: 'PE', lat: -8.2839, lng: -35.9761, populacao: 378052 },
  { nome: 'Blumenau', uf: 'SC', lat: -26.9194, lng: -49.0661, populacao: 361261 },
  { nome: 'Ponta Grossa', uf: 'PR', lat: -25.0950, lng: -50.1619, populacao: 358371 },
  { nome: 'Campinas', uf: 'SP', lat: -22.9056, lng: -47.0608, populacao: 1138309 },
  { nome: 'Guarulhos', uf: 'SP', lat: -23.4542, lng: -46.5333, populacao: 1291784 },
  { nome: 'São Bernardo do Campo', uf: 'SP', lat: -23.6914, lng: -46.5647, populacao: 810729 },
  { nome: 'Santo André', uf: 'SP', lat: -23.6639, lng: -46.5383, populacao: 748919 },
  { nome: 'Osasco', uf: 'SP', lat: -23.5325, lng: -46.7917, populacao: 743432 },
  { nome: 'São José dos Campos', uf: 'SP', lat: -23.1794, lng: -45.8869, populacao: 697428 },
  { nome: 'Niterói', uf: 'RJ', lat: -22.8833, lng: -43.1036, populacao: 481758 },
  { nome: 'São José do Rio Preto', uf: 'SP', lat: -20.8114, lng: -49.3758, populacao: 480439 },
  { nome: 'Vila Velha', uf: 'ES', lat: -20.3297, lng: -40.2925, populacao: 467722 },
  { nome: 'Mogi das Cruzes', uf: 'SP', lat: -23.5208, lng: -46.1856, populacao: 449955 },
  { nome: 'Macapá', uf: 'AP', lat: 0.0389, lng: -51.0664, populacao: 442933 },
  { nome: 'Boa Vista', uf: 'RR', lat: 2.8235, lng: -60.6758, populacao: 413486 },
  { nome: 'Rio Branco', uf: 'AC', lat: -9.9753, lng: -67.8249, populacao: 364756 },
  { nome: 'Porto Velho', uf: 'RO', lat: -8.7619, lng: -63.9039, populacao: 460413 },
  { nome: 'Palmas', uf: 'TO', lat: -10.1844, lng: -48.3336, populacao: 302692 },
  { nome: 'Cuiabá', uf: 'MT', lat: -15.6010, lng: -56.0974, populacao: 650912 },
  { nome: 'Campo Grande', uf: 'MS', lat: -20.4697, lng: -54.6201, populacao: 897938 },
  { nome: 'Teresina', uf: 'PI', lat: -5.0919, lng: -42.8034, populacao: 866300 },
  { nome: 'Aracaju', uf: 'SE', lat: -10.9472, lng: -37.0731, populacao: 602757 },
  { nome: 'Maceió', uf: 'AL', lat: -9.6658, lng: -35.7353, populacao: 957916 },
  { nome: 'João Pessoa', uf: 'PB', lat: -7.1195, lng: -34.8450, populacao: 833932 },
  { nome: 'Natal', uf: 'RN', lat: -5.7945, lng: -35.2110, populacao: 751300 },
  { nome: 'São Luís', uf: 'MA', lat: -2.5307, lng: -44.3068, populacao: 1037775 },
  { nome: 'Belém', uf: 'PA', lat: -1.4558, lng: -48.5039, populacao: 1303389 },
  { nome: 'Manaus', uf: 'AM', lat: -3.1190, lng: -60.0217, populacao: 2063547 },
  { nome: 'Florianópolis', uf: 'SC', lat: -27.5954, lng: -48.5480, populacao: 537213 },
  { nome: 'Vitória', uf: 'ES', lat: -20.3155, lng: -40.3128, populacao: 322869 },
  { nome: 'Cariacica', uf: 'ES', lat: -20.2639, lng: -40.4200, populacao: 353510 },
  { nome: 'Serra', uf: 'ES', lat: -20.1286, lng: -40.3078, populacao: 520653 },
  { nome: 'Linhares', uf: 'ES', lat: -19.3911, lng: -40.0722, populacao: 171606 },
  { nome: 'Colatina', uf: 'ES', lat: -19.5392, lng: -40.6306, populacao: 119938 },
  { nome: 'Guarapari', uf: 'ES', lat: -20.6667, lng: -40.4975, populacao: 124656 },
  { nome: 'São Mateus', uf: 'ES', lat: -18.7161, lng: -39.8589, populacao: 123750 },
  { nome: 'Aracruz', uf: 'ES', lat: -19.8203, lng: -40.2733, populacao: 94765 },
  { nome: 'Cachoeiro de Itapemirim', uf: 'ES', lat: -20.8489, lng: -41.1128, populacao: 185784 },
  { nome: 'Nova Friburgo', uf: 'RJ', lat: -22.2819, lng: -42.5311, populacao: 189937 },
  { nome: 'Petrópolis', uf: 'RJ', lat: -22.5050, lng: -43.1789, populacao: 278881 },
  { nome: 'Teresópolis', uf: 'RJ', lat: -22.4122, lng: -42.9664, populacao: 165123 },
  { nome: 'Macaé', uf: 'RJ', lat: -22.3769, lng: -41.7869, populacao: 246391 },
  { nome: 'Campos dos Goytacazes', uf: 'RJ', lat: -21.7547, lng: -41.3244, populacao: 483551 },
  { nome: 'Cabo Frio', uf: 'RJ', lat: -22.8794, lng: -42.0186, populacao: 221987 },
  { nome: 'Rio das Ostras', uf: 'RJ', lat: -22.5269, lng: -41.9458, populacao: 156491 },
  { nome: 'Resende', uf: 'RJ', lat: -22.4689, lng: -44.4467, populacao: 129612 },
  { nome: 'Volta Redonda', uf: 'RJ', lat: -22.5231, lng: -44.1042, populacao: 261584 },
  { nome: 'Barra Mansa', uf: 'RJ', lat: -22.5442, lng: -44.1714, populacao: 169899 },
  { nome: 'Itaperuna', uf: 'RJ', lat: -21.2056, lng: -41.8875, populacao: 101041 },
  { nome: 'Angra dos Reis', uf: 'RJ', lat: -23.0067, lng: -44.3181, populacao: 167418 },
  { nome: 'Governador Valadares', uf: 'MG', lat: -18.8511, lng: -41.9494, populacao: 257172 },
  { nome: 'Ipatinga', uf: 'MG', lat: -19.4686, lng: -42.5369, populacao: 227731 },
  { nome: 'Coronel Fabriciano', uf: 'MG', lat: -19.5189, lng: -42.6289, populacao: 104736 },
  { nome: 'Timóteo', uf: 'MG', lat: -19.5828, lng: -42.6439, populacao: 81579 },
  { nome: 'Divinópolis', uf: 'MG', lat: -20.1428, lng: -44.8872, populacao: 231091 },
  { nome: 'Sete Lagoas', uf: 'MG', lat: -19.4658, lng: -44.2467, populacao: 227360 },
  { nome: 'Itabira', uf: 'MG', lat: -19.6189, lng: -43.2269, populacao: 113343 },
  { nome: 'Muriaé', uf: 'MG', lat: -21.1306, lng: -42.3664, populacao: 104166 },
  { nome: 'Ubá', uf: 'MG', lat: -21.1203, lng: -42.9428, populacao: 103365 },
  { nome: 'Barbacena', uf: 'MG', lat: -21.2258, lng: -43.7736, populacao: 125317 },
  { nome: 'Teófilo Otoni', uf: 'MG', lat: -17.8575, lng: -41.5053, populacao: 158742 },
  { nome: 'Manhuaçu', uf: 'MG', lat: -20.2581, lng: -42.0336, populacao: 89679 },
  { nome: 'São Carlos', uf: 'SP', lat: -22.0175, lng: -47.8908, populacao: 254484 },
  { nome: 'Araraquara', uf: 'SP', lat: -21.7944, lng: -48.1758, populacao: 242126 },
  { nome: 'Rio Claro', uf: 'SP', lat: -22.4114, lng: -47.5614, populacao: 201418 },
  { nome: 'São João da Boa Vista', uf: 'SP', lat: -21.9689, lng: -46.7978, populacao: 92535 },
  { nome: 'Mogi Mirim', uf: 'SP', lat: -22.4319, lng: -46.9578, populacao: 92559 },
  { nome: 'Mogi Guaçu', uf: 'SP', lat: -22.3708, lng: -46.9428, populacao: 153661 },
  { nome: 'Bragança Paulista', uf: 'SP', lat: -22.9528, lng: -46.5419, populacao: 176811 },
  { nome: 'Atibaia', uf: 'SP', lat: -23.1178, lng: -46.5500, populacao: 158640 },
  { nome: 'Pindamonhangaba', uf: 'SP', lat: -22.9247, lng: -45.4614, populacao: 165428 },
  { nome: 'Taubaté', uf: 'SP', lat: -23.0264, lng: -45.5553, populacao: 310739 },
  { nome: 'Guaratinguetá', uf: 'SP', lat: -22.8164, lng: -45.1928, populacao: 118044 },
  { nome: 'Cruzeiro', uf: 'SP', lat: -22.5739, lng: -44.9639, populacao: 82571 },
  { nome: 'Lorena', uf: 'SP', lat: -22.7339, lng: -45.1242, populacao: 88276 },
  { nome: 'Caraguatatuba', uf: 'SP', lat: -23.6228, lng: -45.4128, populacao: 134875 },
  { nome: 'São Sebastião', uf: 'SP', lat: -23.7600, lng: -45.4097, populacao: 81540 },
  { nome: 'Ubatuba', uf: 'SP', lat: -23.4339, lng: -45.0711, populacao: 92980 },
  { nome: 'Ilhabela', uf: 'SP', lat: -23.7781, lng: -45.3581, populacao: 34934 },
  { nome: 'Jacareí', uf: 'SP', lat: -23.3056, lng: -45.9658, populacao: 240275 },
  { nome: 'Valinhos', uf: 'SP', lat: -22.9708, lng: -46.9958, populacao: 126325 },
  { nome: 'Vinhedo', uf: 'SP', lat: -23.0297, lng: -46.9750, populacao: 76663 },
  { nome: 'Indaiatuba', uf: 'SP', lat: -23.0903, lng: -47.2181, populacao: 255748 },
  { nome: 'Americana', uf: 'SP', lat: -22.7394, lng: -47.3314, populacao: 237247 },
  { nome: 'Santa Bárbara d\'Oeste', uf: 'SP', lat: -22.7539, lng: -47.4142, populacao: 183347 },
  { nome: 'Nova Odessa', uf: 'SP', lat: -22.7806, lng: -47.2961, populacao: 62019 },
  { nome: 'Sumaré', uf: 'SP', lat: -22.8206, lng: -47.2669, populacao: 279546 },
  { nome: 'Hortolândia', uf: 'SP', lat: -22.8583, lng: -47.2200, populacao: 236641 },
  { nome: 'Paulínia', uf: 'SP', lat: -22.7611, lng: -47.1539, populacao: 110537 },
  { nome: 'Amparo', uf: 'SP', lat: -22.7011, lng: -46.7644, populacao: 68070 },
  { nome: 'Itatiba', uf: 'SP', lat: -23.0058, lng: -46.8406, populacao: 122424 },
  { nome: 'Boituva', uf: 'SP', lat: -23.2842, lng: -47.6789, populacao: 61081 },
  { nome: 'Porto Feliz', uf: 'SP', lat: -23.2158, lng: -47.5239, populacao: 56497 },
  { nome: 'Cerquilho', uf: 'SP', lat: -23.1658, lng: -47.7439, populacao: 44695 },
  { nome: 'Tietê', uf: 'SP', lat: -23.1008, lng: -47.7139, populacao: 37607 },
  { nome: 'Pirassununga', uf: 'SP', lat: -21.9961, lng: -47.4258, populacao: 73506 },
  { nome: 'Araras', uf: 'SP', lat: -22.3572, lng: -47.3842, populacao: 130866 },
  { nome: 'Leme', uf: 'SP', lat: -22.1858, lng: -47.3889, populacao: 98145 },
  { nome: 'São José dos Pinhais', uf: 'PR', lat: -25.5347, lng: -49.2064, populacao: 329222 },
  { nome: 'Pinhais', uf: 'PR', lat: -25.4339, lng: -49.1914, populacao: 127019 },
  { nome: 'Colombo', uf: 'PR', lat: -25.2917, lng: -49.2242, populacao: 232056 },
  { nome: 'Campo Largo', uf: 'PR', lat: -25.4594, lng: -49.5264, populacao: 136327 },
  { nome: 'Araucária', uf: 'PR', lat: -25.5928, lng: -49.3347, populacao: 151666 },
  { nome: 'Piraquara', uf: 'PR', lat: -25.4419, lng: -49.0631, populacao: 118730 }
];

// =========================================================================
// FASE 3: Cinturões Industriais & Tecnologia (232 a 338)
// Cidades industriais, hubs de serviços logísticos e cinturões metropolitanos
// =========================================================================
export const RAW_FASE_3 = [
  { nome: 'Fazenda Rio Grande', uf: 'PR', lat: -25.6589, lng: -49.3089, populacao: 148873 },
  { nome: 'Castro', uf: 'PR', lat: -24.7917, lng: -50.0117, populacao: 73044 },
  { nome: 'Telêmaco Borba', uf: 'PR', lat: -24.3239, lng: -50.6158, populacao: 75042 },
  { nome: 'União da Vitória', uf: 'PR', lat: -26.2289, lng: -51.0858, populacao: 55033 },
  { nome: 'Apucarana', uf: 'PR', lat: -23.5514, lng: -51.4614, populacao: 130134 },
  { nome: 'Rolândia', uf: 'PR', lat: -23.3100, lng: -51.3689, populacao: 71670 },
  { nome: 'Barueri', uf: 'SP', lat: -23.5106, lng: -46.8761, populacao: 316473 },
  { nome: 'Betim', uf: 'MG', lat: -19.9676, lng: -44.2001, populacao: 411784 },
  { nome: 'Contagem', uf: 'MG', lat: -19.9317, lng: -44.0536, populacao: 621865 },
  { nome: 'Jaraguá do Sul', uf: 'SC', lat: -26.4850, lng: -49.0700, populacao: 182636 },
  { nome: 'Brusque', uf: 'SC', lat: -27.0989, lng: -48.9169, populacao: 141385 },
  { nome: 'Balneário Camboriú', uf: 'SC', lat: -26.9928, lng: -48.6353, populacao: 139155 },
  { nome: 'Palhoça', uf: 'SC', lat: -27.6456, lng: -48.6681, populacao: 222598 },
  { nome: 'São José', uf: 'SC', lat: -27.6136, lng: -48.6367, populacao: 270295 },
  { nome: 'Criciúma', uf: 'SC', lat: -28.6775, lng: -49.3703, populacao: 214493 },
  { nome: 'Tubarão', uf: 'SC', lat: -28.4800, lng: -49.0069, populacao: 110088 },
  { nome: 'Lages', uf: 'SC', lat: -27.8158, lng: -50.3261, populacao: 164981 },
  { nome: 'São Bento do Sul', uf: 'SC', lat: -26.2503, lng: -49.3800, populacao: 86317 },
  { nome: 'Pelotas', uf: 'RS', lat: -31.7654, lng: -52.3376, populacao: 325689 },
  { nome: 'Santa Maria', uf: 'RS', lat: -29.6842, lng: -53.8069, populacao: 271633 },
  { nome: 'Novo Hamburgo', uf: 'RS', lat: -29.6789, lng: -51.1308, populacao: 227732 },
  { nome: 'São Leopoldo', uf: 'RS', lat: -29.7600, lng: -51.1472, populacao: 217410 },
  { nome: 'Canoas', uf: 'RS', lat: -29.9178, lng: -51.1839, populacao: 347657 },
  { nome: 'Gravataí', uf: 'RS', lat: -29.9439, lng: -50.9928, populacao: 265070 },
  { nome: 'Viamão', uf: 'RS', lat: -30.0811, lng: -51.0233, populacao: 224116 },
  { nome: 'Alvorada', uf: 'RS', lat: -30.0039, lng: -51.0828, populacao: 187315 },
  { nome: 'Cachoeirinha', uf: 'RS', lat: -29.9508, lng: -51.0942, populacao: 136229 },
  { nome: 'Sapucaia do Sul', uf: 'RS', lat: -29.8378, lng: -51.1458, populacao: 132107 },
  { nome: 'Esteio', uf: 'RS', lat: -29.8600, lng: -51.1817, populacao: 76137 },
  { nome: 'Guaíba', uf: 'RS', lat: -30.1139, lng: -51.3250, populacao: 92924 },
  { nome: 'Farroupilha', uf: 'RS', lat: -29.2242, lng: -51.3458, populacao: 69885 },
  { nome: 'Gramado', uf: 'RS', lat: -29.3789, lng: -50.8739, populacao: 40134 },
  { nome: 'Canela', uf: 'RS', lat: -29.3650, lng: -50.8144, populacao: 48946 },
  { nome: 'Torres', uf: 'RS', lat: -29.3358, lng: -49.7289, populacao: 41751 },
  { nome: 'Capão da Canoa', uf: 'RS', lat: -29.7458, lng: -50.0139, populacao: 54051 },
  { nome: 'Tramandaí', uf: 'RS', lat: -29.9850, lng: -50.1339, populacao: 54387 },
  { nome: 'Itaquaquecetuba', uf: 'SP', lat: -23.4861, lng: -46.3483, populacao: 369275 },
  { nome: 'Mauá', uf: 'SP', lat: -23.6678, lng: -46.4614, populacao: 418261 },
  { nome: 'Mairiporã', uf: 'SP', lat: -23.3189, lng: -46.5869, populacao: 93617 },
  { nome: 'Arujá', uf: 'SP', lat: -23.3967, lng: -46.3206, populacao: 86678 },
  { nome: 'Ferraz de Vasconcelos', uf: 'SP', lat: -23.5414, lng: -46.3686, populacao: 179198 },
  { nome: 'Poá', uf: 'SP', lat: -23.5208, lng: -46.3458, populacao: 103765 },
  { nome: 'Suzano', uf: 'SP', lat: -23.5428, lng: -46.3108, populacao: 307387 },
  { nome: 'Ribeirão Pires', uf: 'SP', lat: -23.7139, lng: -46.4139, populacao: 115559 },
  { nome: 'São Caetano do Sul', uf: 'SP', lat: -23.6228, lng: -46.5550, populacao: 165655 },
  { nome: 'Diadema', uf: 'SP', lat: -23.6864, lng: -46.6228, populacao: 393237 },
  { nome: 'Cotia', uf: 'SP', lat: -23.6039, lng: -46.9189, populacao: 273640 },
  { nome: 'Taboão da Serra', uf: 'SP', lat: -23.6261, lng: -46.7578, populacao: 273542 },
  { nome: 'Embu das Artes', uf: 'SP', lat: -23.6489, lng: -46.8522, populacao: 250720 },
  { nome: 'Itapevi', uf: 'SP', lat: -23.5489, lng: -46.9328, populacao: 232297 },
  { nome: 'Jandira', uf: 'SP', lat: -23.5278, lng: -46.9028, populacao: 118045 },
  { nome: 'Santana de Parnaíba', uf: 'SP', lat: -23.4439, lng: -46.9178, populacao: 154105 },
  { nome: 'Caieiras', uf: 'SP', lat: -23.3644, lng: -46.7408, populacao: 95030 },
  { nome: 'Franco da Rocha', uf: 'SP', lat: -23.3283, lng: -46.7267, populacao: 144849 },
  { nome: 'Francisco Morato', uf: 'SP', lat: -23.2817, lng: -46.7439, populacao: 165139 },
  { nome: 'Camaçari', uf: 'BA', lat: -12.6975, lng: -38.3242, populacao: 299558 },
  { nome: 'Lauro de Freitas', uf: 'BA', lat: -12.8944, lng: -38.3272, populacao: 203334 },
  { nome: 'Simões Filho', uf: 'BA', lat: -12.7869, lng: -38.4039, populacao: 114441 },
  { nome: 'Dias d\'Ávila', uf: 'BA', lat: -12.6178, lng: -38.2978, populacao: 71485 },
  { nome: 'Candeias', uf: 'BA', lat: -12.6694, lng: -38.5469, populacao: 72382 },
  { nome: 'Maracanaú', uf: 'CE', lat: -3.8767, lng: -38.6256, populacao: 234392 },
  { nome: 'Eusébio', uf: 'CE', lat: -3.8906, lng: -38.4558, populacao: 74170 },
  { nome: 'Caucaia', uf: 'CE', lat: -3.7361, lng: -38.6531, populacao: 355679 },
  { nome: 'Aquiraz', uf: 'CE', lat: -3.9014, lng: -38.3911, populacao: 80243 },
  { nome: 'Maranguape', uf: 'CE', lat: -3.8894, lng: -38.6839, populacao: 105093 },
  { nome: 'São Gonçalo do Amarante', uf: 'CE', lat: -3.6069, lng: -38.9694, populacao: 54021 },
  { nome: 'Jaboatão dos Guararapes', uf: 'PE', lat: -8.1128, lng: -35.0150, populacao: 643759 },
  { nome: 'Olinda', uf: 'PE', lat: -7.9986, lng: -34.8458, populacao: 349976 },
  { nome: 'Paulista', uf: 'PE', lat: -7.9408, lng: -34.8728, populacao: 342167 },
  { nome: 'Cabo de Santo Agostinho', uf: 'PE', lat: -8.2833, lng: -35.0333, populacao: 203216 },
  { nome: 'Ipojuca', uf: 'PE', lat: -8.3989, lng: -35.0639, populacao: 97637 },
  { nome: 'Camaragibe', uf: 'PE', lat: -8.0219, lng: -34.9819, populacao: 147771 },
  { nome: 'Igarassu', uf: 'PE', lat: -7.8342, lng: -34.9064, populacao: 115196 },
  { nome: 'São Lourenço da Mata', uf: 'PE', lat: -8.0028, lng: -35.0189, populacao: 111249 },
  { nome: 'Vitória de Santo Antão', uf: 'PE', lat: -8.1189, lng: -35.2928, populacao: 134110 },
  { nome: 'Parnamirim', uf: 'RN', lat: -5.9156, lng: -35.2628, populacao: 252716 },
  { nome: 'Macaíba', uf: 'RN', lat: -5.8583, lng: -35.3539, populacao: 82212 },
  { nome: 'Nossa Senhora do Socorro', uf: 'SE', lat: -10.8547, lng: -37.1264, populacao: 192330 },
  { nome: 'Estância', uf: 'SE', lat: -11.2683, lng: -37.4383, populacao: 65078 },
  { nome: 'Lagarto', uf: 'SE', lat: -10.9172, lng: -37.6500, populacao: 101579 },
  { nome: 'Itabaiana', uf: 'SE', lat: -10.6850, lng: -37.4253, populacao: 103440 },
  { nome: 'São Cristóvão', uf: 'SE', lat: -11.0147, lng: -37.2064, populacao: 95612 },
  { nome: 'Arapiraca', uf: 'AL', lat: -9.7519, lng: -36.6606, populacao: 234696 },
  { nome: 'Marechal Deodoro', uf: 'AL', lat: -9.7111, lng: -35.8967, populacao: 60370 },
  { nome: 'Rio Largo', uf: 'AL', lat: -9.4778, lng: -35.8539, populacao: 93927 },
  { nome: 'Santa Rita', uf: 'PB', lat: -7.1139, lng: -34.9781, populacao: 149910 },
  { nome: 'Bayeux', uf: 'PB', lat: -7.1250, lng: -34.9322, populacao: 82742 },
  { nome: 'Cabedelo', uf: 'PB', lat: -6.9811, lng: -34.8339, populacao: 66519 },
  { nome: 'Ananindeua', uf: 'PA', lat: -1.3656, lng: -48.3722, populacao: 478778 },
  { nome: 'Marituba', uf: 'PA', lat: -1.3556, lng: -48.3414, populacao: 111785 },
  { nome: 'Benevides', uf: 'PA', lat: -1.3614, lng: -48.2458, populacao: 63768 },
  { nome: 'Barcarena', uf: 'PA', lat: -1.5058, lng: -48.6197, populacao: 126686 },
  { nome: 'Santana', uf: 'AP', lat: -0.0583, lng: -51.1817, populacao: 107618 },
  { nome: 'Ji-Paraná', uf: 'RO', lat: -10.8842, lng: -61.9514, populacao: 124333 },
  { nome: 'Ariquemes', uf: 'RO', lat: -9.9133, lng: -63.0408, populacao: 96833 },
  { nome: 'Vilhena', uf: 'RO', lat: -12.7406, lng: -60.1458, populacao: 95832 },
  { nome: 'Cacoal', uf: 'RO', lat: -11.4386, lng: -61.4472, populacao: 86895 },
  { nome: 'Cruzeiro do Sul', uf: 'AC', lat: -7.6311, lng: -72.6700, populacao: 91888 },
  { nome: 'Parintins', uf: 'AM', lat: -2.6289, lng: -56.7358, populacao: 96372 },
  { nome: 'Itacoatiara', uf: 'AM', lat: -3.1431, lng: -58.4442, populacao: 103598 },
  { nome: 'Manacapuru', uf: 'AM', lat: -3.2997, lng: -60.6206, populacao: 101883 },
  { nome: 'Trindade', uf: 'GO', lat: -16.6489, lng: -49.4914, populacao: 142435 },
  { nome: 'Aparecida de Goiânia', uf: 'GO', lat: -16.8228, lng: -49.2481, populacao: 527550 },
  { nome: 'Valparaíso de Goiás', uf: 'GO', lat: -16.0689, lng: -47.9758, populacao: 198861 },
  { nome: 'Luziânia', uf: 'GO', lat: -16.2525, lng: -47.9500, populacao: 208725 },
  { nome: 'Águas Lindas de Goiás', uf: 'GO', lat: -15.7622, lng: -48.2819, populacao: 225671 },
  { nome: 'Caldas Novas', uf: 'GO', lat: -17.7444, lng: -48.6258, populacao: 98319 }
];

// =========================================================================
// FASE 4: Metrópoles Globais e Expansão Comercial (339 a 500)
// Maiores capitais nacionais e polos secundários de alta densidade
// =========================================================================
export const RAW_FASE_4 = [
  { nome: 'São Paulo', uf: 'SP', lat: -23.5505, lng: -46.6333, populacao: 11451245 },
  { nome: 'Rio de Janeiro', uf: 'RJ', lat: -22.9068, lng: -43.1729, populacao: 6211423 },
  { nome: 'Brasília', uf: 'DF', lat: -15.7975, lng: -47.8919, populacao: 2817068 },
  { nome: 'Fortaleza', uf: 'CE', lat: -3.7172, lng: -38.5437, populacao: 2428678 },
  { nome: 'Salvador', uf: 'BA', lat: -12.9777, lng: -38.5016, populacao: 2418005 },
  { nome: 'Belo Horizonte', uf: 'MG', lat: -19.9167, lng: -43.9345, populacao: 2315560 },
  { nome: 'Curitiba', uf: 'PR', lat: -25.4284, lng: -49.2733, populacao: 1773733 },
  { nome: 'Recife', uf: 'PE', lat: -8.0476, lng: -34.8770, populacao: 1488920 },
  { nome: 'Goiânia', uf: 'GO', lat: -16.6869, lng: -49.2648, populacao: 1437237 },
  { nome: 'Porto Alegre', uf: 'RS', lat: -30.0346, lng: -51.2177, populacao: 1332570 },
  { nome: 'Duque de Caxias', uf: 'RJ', lat: -22.7858, lng: -43.3117, populacao: 808152 },
  { nome: 'Nova Iguaçu', uf: 'RJ', lat: -22.7558, lng: -43.4603, populacao: 785867 },
  { nome: 'São Gonçalo', uf: 'RJ', lat: -22.8269, lng: -43.0539, populacao: 896744 },
  { nome: 'Belford Roxo', uf: 'RJ', lat: -22.7642, lng: -43.3997, populacao: 483087 },
  { nome: 'São João de Meriti', uf: 'RJ', lat: -22.8042, lng: -43.3725, populacao: 440962 },
  { nome: 'Carapicuíba', uf: 'SP', lat: -23.5222, lng: -46.8356, populacao: 387121 },
  { nome: 'Ibiporã', uf: 'PR', lat: -23.2694, lng: -51.0478, populacao: 51603 },
  { nome: 'Cambé', uf: 'PR', lat: -23.2758, lng: -51.2789, populacao: 107208 },
  { nome: 'Sertanópolis', uf: 'PR', lat: -23.0589, lng: -51.0369, populacao: 16000 },
  { nome: 'São Francisco do Sul', uf: 'SC', lat: -26.2428, lng: -48.6381, populacao: 53746 },
  { nome: 'Navegantes', uf: 'SC', lat: -26.8964, lng: -48.6542, populacao: 86401 },
  { nome: 'Gaspar', uf: 'SC', lat: -26.9317, lng: -48.9592, populacao: 72570 },
  { nome: 'Indaial', uf: 'SC', lat: -26.8989, lng: -49.2319, populacao: 71509 },
  { nome: 'Pomerode', uf: 'SC', lat: -26.7400, lng: -49.1764, populacao: 34061 },
  { nome: 'Timbó', uf: 'SC', lat: -26.8239, lng: -49.2719, populacao: 44977 },
  { nome: 'Votorantim', uf: 'SP', lat: -23.5414, lng: -47.4378, populacao: 127923 },
  { nome: 'Porto Ferreira', uf: 'SP', lat: -21.8542, lng: -47.4497, populacao: 52649 },
  { nome: 'Jaboticabal', uf: 'SP', lat: -21.2558, lng: -48.3228, populacao: 71821 },
  { nome: 'Taquaritinga', uf: 'SP', lat: -21.4058, lng: -48.5050, populacao: 52260 },
  { nome: 'Mirassol', uf: 'SP', lat: -20.8197, lng: -49.5039, populacao: 63337 },
  { nome: 'Penápolis', uf: 'SP', lat: -21.4200, lng: -50.0778, populacao: 61681 },
  { nome: 'Garça', uf: 'SP', lat: -22.2108, lng: -49.6542, populacao: 42110 },
  { nome: 'Tupã', uf: 'SP', lat: -21.9347, lng: -50.5139, populacao: 63928 },
  { nome: 'Adamantina', uf: 'SP', lat: -21.6850, lng: -51.0728, populacao: 34687 },
  { nome: 'Dracena', uf: 'SP', lat: -21.4828, lng: -51.5331, populacao: 45474 },
  { nome: 'Presidente Epitácio', uf: 'SP', lat: -21.7639, lng: -52.1150, populacao: 39505 },
  { nome: 'Santa Cruz do Rio Pardo', uf: 'SP', lat: -22.8989, lng: -49.6328, populacao: 46442 },
  { nome: 'Mandaguari', uf: 'PR', lat: -23.5469, lng: -51.7728, populacao: 36716 },
  { nome: 'Marialva', uf: 'PR', lat: -23.4858, lng: -51.7919, populacao: 35894 },
  { nome: 'Paiçandu', uf: 'PR', lat: -23.4578, lng: -52.0489, populacao: 45934 },
  { nome: 'Sarandi', uf: 'PR', lat: -23.4439, lng: -51.8739, populacao: 118455 },
  { nome: 'Cianorte', uf: 'PR', lat: -23.6639, lng: -52.6050, populacao: 79527 },
  { nome: 'Nova Esperança', uf: 'PR', lat: -23.1839, lng: -52.2050, populacao: 26613 },
  { nome: 'Colorado', uf: 'PR', lat: -22.8378, lng: -51.9728, populacao: 22896 },
  { nome: 'Loanda', uf: 'PR', lat: -22.9242, lng: -53.1369, populacao: 23223 },
  { nome: 'Cruzeiro do Oeste', uf: 'PR', lat: -23.7839, lng: -53.0750, populacao: 23831 },
  { nome: 'Goioerê', uf: 'PR', lat: -24.1844, lng: -53.0269, populacao: 28437 },
  { nome: 'Guaíra', uf: 'PR', lat: -24.0817, lng: -54.2569, populacao: 32097 },
  { nome: 'Marechal Cândido Rondon', uf: 'PR', lat: -24.5558, lng: -54.0569, populacao: 55836 },
  { nome: 'São Miguel do Iguaçu', uf: 'PR', lat: -25.3478, lng: -54.2417, populacao: 29122 },
  { nome: 'Matelândia', uf: 'PR', lat: -25.2417, lng: -53.9961, populacao: 18450 },
  { nome: 'Capanema', uf: 'PR', lat: -25.6719, lng: -53.8089, populacao: 20481 },
  { nome: 'Dois Vizinhos', uf: 'PR', lat: -25.7508, lng: -53.0569, populacao: 44869 },
  { nome: 'Palmas', uf: 'PR', lat: -26.4839, lng: -51.9931, populacao: 48241 },
  { nome: 'Laranjeiras do Sul', uf: 'PR', lat: -25.4078, lng: -52.4158, populacao: 32227 },
  { nome: 'Prudentópolis', uf: 'PR', lat: -25.2131, lng: -50.9778, populacao: 49393 },
  { nome: 'Irati', uf: 'PR', lat: -25.4678, lng: -50.6514, populacao: 59250 },
  { nome: 'Piraí do Sul', uf: 'PR', lat: -24.5269, lng: -50.1389, populacao: 23635 },
  { nome: 'Jaguariaíva', uf: 'PR', lat: -24.2508, lng: -49.7058, populacao: 35141 },
  { nome: 'Ibaiti', uf: 'PR', lat: -23.8489, lng: -50.1878, populacao: 28830 },
  { nome: 'Cornélio Procópio', uf: 'PR', lat: -23.1811, lng: -50.6469, populacao: 45206 },
  { nome: 'Bandeirantes', uf: 'PR', lat: -23.1114, lng: -50.3669, populacao: 31273 },
  { nome: 'Jacarezinho', uf: 'PR', lat: -23.1589, lng: -49.9719, populacao: 40375 },
  { nome: 'Santo Antônio da Platina', uf: 'PR', lat: -23.2950, lng: -50.0789, populacao: 44369 },
  { nome: 'Morretes', uf: 'PR', lat: -25.4747, lng: -48.8339, populacao: 18309 },
  { nome: 'Paranaguá', uf: 'PR', lat: -25.5206, lng: -48.5092, populacao: 145829 },
  { nome: 'Antonina', uf: 'PR', lat: -25.4289, lng: -48.7119, populacao: 18091 },
  { nome: 'Guaratuba', uf: 'PR', lat: -25.8828, lng: -48.5747, populacao: 42062 },
  { nome: 'Matinhos', uf: 'PR', lat: -25.8178, lng: -48.5428, populacao: 39259 },
  { nome: 'Pontal do Paraná', uf: 'PR', lat: -25.6889, lng: -48.5139, populacao: 30425 },
  { nome: 'Campina Grande do Sul', uf: 'PR', lat: -25.3050, lng: -49.0558, populacao: 47768 },
  { nome: 'Quatro Barras', uf: 'PR', lat: -25.3658, lng: -49.0758, populacao: 24191 },
  { nome: 'Balsa Nova', uf: 'PR', lat: -25.5842, lng: -49.6358, populacao: 13312 },
  { nome: 'Contenda', uf: 'PR', lat: -25.6769, lng: -49.5339, populacao: 19128 },
  { nome: 'Mandirituba', uf: 'PR', lat: -25.7789, lng: -49.3258, populacao: 27434 },
  { nome: 'Quitandinha', uf: 'PR', lat: -25.8719, lng: -49.4978, populacao: 18397 },
  { nome: 'Tijucas do Sul', uf: 'PR', lat: -25.9289, lng: -49.1978, populacao: 17606 },
  { nome: 'Rio Branco do Sul', uf: 'PR', lat: -25.1906, lng: -49.3139, populacao: 37558 },
  { nome: 'Itaperuçu', uf: 'PR', lat: -25.2208, lng: -49.3478, populacao: 31217 },
  { nome: 'Cerro Azul', uf: 'PR', lat: -24.8239, lng: -49.2608, populacao: 16134 },
  { nome: 'Bocaiúva do Sul', uf: 'PR', lat: -25.2058, lng: -49.1147, populacao: 13299 },
  { nome: 'Adrianópolis', uf: 'PR', lat: -24.6569, lng: -48.9919, populacao: 6256 },
  { nome: 'Campos Novos', uf: 'SC', lat: -27.4019, lng: -51.2258, populacao: 36932 },
  { nome: 'Curitibanos', uf: 'SC', lat: -27.2828, lng: -50.5842, populacao: 40045 },
  { nome: 'Fraiburgo', uf: 'SC', lat: -27.0258, lng: -50.9219, populacao: 33481 },
  { nome: 'São Miguel do Oeste', uf: 'SC', lat: -26.7269, lng: -53.5178, populacao: 44330 },
  { nome: 'Maravilha', uf: 'SC', lat: -26.7619, lng: -53.1728, populacao: 28251 },
  { nome: 'Xaxim', uf: 'SC', lat: -26.9608, lng: -52.5358, populacao: 31918 },
  { nome: 'Getúlio Vargas', uf: 'RS', lat: -27.8908, lng: -52.2269, populacao: 16654 },
  { nome: 'Lagoa Vermelha', uf: 'RS', lat: -28.2089, lng: -51.5258, populacao: 27659 },
  { nome: 'Sananduva', uf: 'RS', lat: -27.9469, lng: -51.8069, populacao: 16399 },
  { nome: 'Garibaldi', uf: 'RS', lat: -29.2558, lng: -51.5339, populacao: 34335 },
  { nome: 'Carlos Barbosa', uf: 'RS', lat: -29.2978, lng: -51.5039, populacao: 30418 },
  { nome: 'Veranópolis', uf: 'RS', lat: -28.9358, lng: -51.5489, populacao: 24021 },
  { nome: 'Nova Prata', uf: 'RS', lat: -28.7842, lng: -51.6097, populacao: 25692 },
  { nome: 'Guaporé', uf: 'RS', lat: -28.8458, lng: -51.8900, populacao: 25268 },
  { nome: 'Marau', uf: 'RS', lat: -28.4489, lng: -52.1989, populacao: 45126 },
  { nome: 'Soledade', uf: 'RS', lat: -28.8189, lng: -52.5100, populacao: 30065 },
  { nome: 'Santo Ângelo', uf: 'RS', lat: -28.2989, lng: -54.2631, populacao: 76917 },
  { nome: 'São Luiz Gonzaga', uf: 'RS', lat: -28.4089, lng: -54.9608, populacao: 34752 },
  { nome: 'Itaqui', uf: 'RS', lat: -29.1258, lng: -56.5539, populacao: 35768 },
  { nome: 'São Borja', uf: 'RS', lat: -28.6608, lng: -56.0044, populacao: 59676 },
  { nome: 'Uruguaiana', uf: 'RS', lat: -29.7547, lng: -57.0853, populacao: 117210 },
  { nome: 'Alegrete', uf: 'RS', lat: -29.7839, lng: -55.7919, populacao: 72409 },
  { nome: 'Sant\'Ana do Livramento', uf: 'RS', lat: -30.8842, lng: -55.5328, populacao: 76321 },
  { nome: 'Rosário do Sul', uf: 'RS', lat: -30.2581, lng: -54.9142, populacao: 36630 },
  { nome: 'São Gabriel', uf: 'RS', lat: -30.3361, lng: -54.3200, populacao: 58448 },
  { nome: 'Dom Pedrito', uf: 'RS', lat: -30.9828, lng: -54.6731, populacao: 36981 },
  { nome: 'Rio Grande', uf: 'RS', lat: -32.0350, lng: -52.0986, populacao: 191900 },
  { nome: 'São Lourenço do Sul', uf: 'RS', lat: -31.3658, lng: -51.9778, populacao: 41989 },
  { nome: 'Camaquã', uf: 'RS', lat: -30.8519, lng: -51.8119, populacao: 62227 },
  { nome: 'Conceição do Jacuípe', uf: 'BA', lat: -12.3258, lng: -38.7658, populacao: 35308 },
  { nome: 'Cruz das Almas', uf: 'BA', lat: -12.6739, lng: -39.1039, populacao: 60346 },
  { nome: 'Itapetinga', uf: 'BA', lat: -15.2489, lng: -40.2478, populacao: 65897 },
  { nome: 'Guanambi', uf: 'BA', lat: -14.2231, lng: -42.7814, populacao: 87817 },
  { nome: 'Brumado', uf: 'BA', lat: -14.2039, lng: -41.6658, populacao: 70512 },
  { nome: 'Irecê', uf: 'BA', lat: -11.3039, lng: -41.8558, populacao: 74507 },
  { nome: 'Jacobina', uf: 'BA', lat: -11.1819, lng: -40.5181, populacao: 82590 },
  { nome: 'Paulo Afonso', uf: 'BA', lat: -9.4058, lng: -38.2178, populacao: 112870 },
  { nome: 'Propriá', uf: 'SE', lat: -10.2119, lng: -36.8408, populacao: 26618 },
  { nome: 'Tobias Barreto', uf: 'SE', lat: -11.1828, lng: -37.9989, populacao: 50905 },
  { nome: 'Delmiro Gouveia', uf: 'AL', lat: -9.3858, lng: -37.9989, populacao: 51319 },
  { nome: 'Coruripe', uf: 'AL', lat: -10.1258, lng: -36.1758, populacao: 50414 },
  { nome: 'Santana do Ipanema', uf: 'AL', lat: -9.3758, lng: -37.2439, populacao: 46222 },
  { nome: 'São Miguel dos Campos', uf: 'AL', lat: -9.7819, lng: -36.0939, populacao: 51989 },
  { nome: 'Murici', uf: 'AL', lat: -9.3089, lng: -35.9419, populacao: 28333 },
  { nome: 'Arcoverde', uf: 'PE', lat: -8.4189, lng: -37.0539, populacao: 77742 },
  { nome: 'Salgueiro', uf: 'PE', lat: -8.0739, lng: -39.1197, populacao: 62372 },
  { nome: 'Ouricuri', uf: 'PE', lat: -7.8828, lng: -40.0819, populacao: 65379 },
  { nome: 'Belo Jardim', uf: 'PE', lat: -8.3347, lng: -36.4239, populacao: 79506 },
  { nome: 'Toritama', uf: 'PE', lat: -7.9989, lng: -36.0569, populacao: 41102 },
  { nome: 'Surubim', uf: 'PE', lat: -7.8328, lng: -35.7539, populacao: 64120 },
  { nome: 'Limoeiro', uf: 'PE', lat: -7.8739, lng: -35.4508, populacao: 56360 },
  { nome: 'Carpina', uf: 'PE', lat: -7.8508, lng: -35.2508, populacao: 79282 },
  { nome: 'Timbaúba', uf: 'PE', lat: -7.5039, lng: -35.3189, populacao: 46801 },
  { nome: 'Goiana', uf: 'PE', lat: -7.5589, lng: -35.0019, populacao: 81055 },
  { nome: 'Abreu e Lima', uf: 'PE', lat: -7.9108, lng: -34.9019, populacao: 98639 },
  { nome: 'Gravatá', uf: 'PE', lat: -8.2019, lng: -35.5658, populacao: 86516 },
  { nome: 'Palmares', uf: 'PE', lat: -8.6839, lng: -35.5919, populacao: 54592 },
  { nome: 'Escada', uf: 'PE', lat: -8.3589, lng: -35.2239, populacao: 59885 },
  { nome: 'Sousa', uf: 'PB', lat: -6.7619, lng: -38.2289, populacao: 67259 },
  { nome: 'Cajazeiras', uf: 'PB', lat: -6.8878, lng: -38.5589, populacao: 63239 },
  { nome: 'Patos', uf: 'PB', lat: -7.0247, lng: -37.2800, populacao: 103165 },
  { nome: 'Guarabira', uf: 'PB', lat: -6.8558, lng: -35.4900, populacao: 57484 },
  { nome: 'Sapé', uf: 'PB', lat: -7.0964, lng: -35.2328, populacao: 51306 },
  { nome: 'Mamanguape', uf: 'PB', lat: -6.8389, lng: -35.1258, populacao: 44599 }
];

// Helper para montar lista MasterCity completa do B2B
export function getB2BCitiesList(phase?: 1 | 2 | 3 | 4): Array<{
  nome: string;
  uf: string;
  populacao: number;
  regiao: 'Sudeste' | 'Sul' | 'Nordeste' | 'Centro-Oeste' | 'Norte';
  isCapital: boolean;
  lat: number;
  lng: number;
}> {
  const getRegion = (uf: string): 'Sudeste' | 'Sul' | 'Nordeste' | 'Centro-Oeste' | 'Norte' => {
    if (['SP', 'RJ', 'MG', 'ES'].includes(uf)) return 'Sudeste';
    if (['PR', 'SC', 'RS'].includes(uf)) return 'Sul';
    if (['BA', 'PE', 'CE', 'RN', 'PB', 'AL', 'SE', 'PI', 'MA'].includes(uf)) return 'Nordeste';
    if (['GO', 'MT', 'MS', 'DF'].includes(uf)) return 'Centro-Oeste';
    return 'Norte';
  };

  const capitals = new Set([
    'São Paulo', 'Rio de Janeiro', 'Brasília', 'Fortaleza', 'Salvador', 
    'Belo Horizonte', 'Curitiba', 'Manaus', 'Recife', 'Porto Alegre', 
    'Belém', 'Goiânia', 'São Luís', 'Maceió', 'Campo Grande', 
    'Natal', 'Teresina', 'João Pessoa', 'Aracaju', 'Cuiabá', 
    'Porto Velho', 'Florianópolis', 'Macapá', 'Rio Branco', 'Vitória', 
    'Boa Vista', 'Palmas'
  ]);

  let rawList: Array<{ nome: string; uf: string; lat: number; lng: number; populacao?: number }> = [];

  if (phase === 1) rawList = RAW_FASE_1;
  else if (phase === 2) rawList = RAW_FASE_2;
  else if (phase === 3) rawList = RAW_FASE_3;
  else if (phase === 4) rawList = RAW_FASE_4;
  else {
    // Todos os 500 em ordem sequencial (Fase 1 -> Fase 2 -> Fase 3 -> Fase 4) com remoção de duplicados preservando primeira ocorrência
    const seen = new Set<string>();
    const all = [...RAW_FASE_1, ...RAW_FASE_2, ...RAW_FASE_3, ...RAW_FASE_4];
    all.forEach(c => {
      const key = `${c.nome}-${c.uf}`.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        rawList.push(c);
      }
    });
  }

  return rawList.map(c => ({
    nome: c.nome,
    uf: c.uf,
    populacao: c.populacao || 50000,
    regiao: getRegion(c.uf),
    isCapital: capitals.has(c.nome),
    lat: c.lat,
    lng: c.lng
  }));
}
